module.exports = {
	"id": "BO",
	"name": "Bolivia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.014388,
			"9": null,
			"10": null,
			"11": 0.057552,
			"12": 0.004796,
			"13": 0.009592,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.038368,
			"19": null,
			"20": null,
			"21": 0.014388,
			"22": 0.028776,
			"23": 0.033572,
			"24": 0.009592,
			"25": 0.067144,
			"26": 0.038368,
			"27": 0.009592,
			"28": 0.009592,
			"29": 0.033572,
			"30": 0.009592,
			"31": 0.091124,
			"32": 0.009592,
			"33": 0.09592,
			"34": 0.028776,
			"35": 0.038368,
			"36": 0.062348,
			"37": 0.028776,
			"38": 0.110308,
			"39": 0.07194,
			"40": 0.067144,
			"41": 0.043164,
			"42": 0.033572,
			"43": 0.230208,
			"44": 0.134288,
			"45": 0.09592,
			"46": 0.105512,
			"47": 0.16786,
			"48": 0.182248,
			"49": 2.345244,
			"50": 0.220616,
			"51": 0.62348,
			"52": 0.609092,
			"53": 18.77634,
			"54": 5.088556,
			"55": 0.038368,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.038368,
			"4": 0.014388,
			"5": 0.009592,
			"6": null,
			"7": null,
			"8": 0.019184,
			"9": 0.004796,
			"10": 0.004796,
			"11": 0.004796,
			"12": 0.033572,
			"13": 0.004796,
			"14": 0.009592,
			"15": 0.009592,
			"16": 0.019184,
			"17": 0.038368,
			"18": 0.014388,
			"19": 0.014388,
			"20": 0.019184,
			"21": 0.009592,
			"22": 0.014388,
			"23": 0.014388,
			"24": 0.014388,
			"25": 0.02398,
			"26": 0.019184,
			"27": 0.014388,
			"28": 0.014388,
			"29": 0.028776,
			"30": 0.043164,
			"31": 0.038368,
			"32": 0.033572,
			"33": 0.052756,
			"34": 0.067144,
			"35": 0.081532,
			"36": 0.057552,
			"37": 0.09592,
			"38": 0.14388,
			"39": 0.110308,
			"40": 0.091124,
			"41": 0.076736,
			"42": 0.100716,
			"43": 0.537152,
			"44": 0.129492,
			"45": 0.211024,
			"46": 0.14388,
			"47": 0.86328,
			"48": 0.76736,
			"49": 5.606524,
			"50": 0.067144,
			"51": 0.019184,
			"52": null,
			"3.5": 0.014388,
			"3.6": 0.033572
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.009592,
			"30": null,
			"31": 0.009592,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.004796,
			"36": 0.033572,
			"37": 0.076736,
			"38": 0.02398,
			"39": 0.019184,
			"40": 0.354904,
			"41": 0.057552,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.009592
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.009592,
			"6": 0.009592,
			"7": 0.014388,
			"8": 0.14388,
			"9": 0.1199,
			"10": 0.378884,
			"3.1": null,
			"3.2": null,
			"5.1": 0.038368,
			"6.1": 0.009592,
			"7.1": 0.004796,
			"9.1": 0.302148
		},
		"ios_saf": {
			"8": 0,
			"10": 1.4229755204,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0383475437136,
			"8.1-8.4": 0.0708454621149,
			"9.0-9.2": 0.0337978351374,
			"9.3": 0.515633638634
		},
		"android": {
			"3": 0,
			"4": 0.128580485788,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0160725607235,
			"4.1": 0.463808180879,
			"4.2-4.3": 1.1595204522,
			"4.4": 2.65886075969,
			"4.4.3-4.4.4": 2.68182156072
		},
		"ie": {
			"6": 0.0096627027027,
			"7": 0.0096627027027,
			"8": 0.391339459459,
			"9": 0.17876,
			"10": 0.265724324324,
			"11": 1.11121081081,
			"5.5": null
		},
		"op_mob": {
			"0": 0.357446079374,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00992905776038
		},
		"edge": {
			"12": 0.057552,
			"13": 0.148676,
			"14": 0.196636
		},
		"ie_mob": {
			"10": 0.0974833802817,
			"11": 0.396896619718
		},
		"bb": {
			"7": 0.009107,
			"10": null
		},
		"samsung": {
			"0": 6.14072
		},
		"and_uc": {
			"0": 2.388636
		},
		"op_mini": {
			"0": 4.81580886287
		},
		"and_chr": {
			"0": 32.240032
		},
		"and_ff": {
			"0": 0.036428
		}
	},
	"total": 99.158491
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BO.json
 ** module id = 482
 ** module chunks = 0
 **/